<script setup lang="ts" name="Card">
import InfoTooltip from '~/components/InfoTooltip.vue';

const { variant = 'shadow' } = defineProps<{
  title?: string;
  tooltip?: string;
  variant?: 'shadow' | 'none' | 'border';
}>();
</script>

<template>
  <div
    class="flex flex-col rounded-md bg-white p-6"
    :class="{
      'drop-shadow': variant === 'shadow',
      'border border-charcoal-2': variant === 'border',
    }"
  >
    <div
      v-if="title"
      class="mb-4 shrink-0"
      :class="{ 'flex justify-between': !!tooltip }"
    >
      <p class="text-subtitle-1 text-charcoal-9">{{ title }}</p>

      <InfoTooltip v-if="tooltip" :description="tooltip" />
    </div>

    <div class="flex-1">
      <slot />
    </div>
  </div>
</template>
